<template src="./template.html"></template>
<script>
import DetailPage from 'src/modules/pages/detail-page'

export default {
  name: 'JobDetail',
  props: ['id', 'mode'],
  data () {
    return {
      scaffolding: {
        'items': {
          'item-1': {
            'indexColumn': true,
            'dataType': 'SingleArray',
            'editable': this.hasPerm,
            'inputKey': 1,
            'type': 'DataTable',
            'hideBottom': true,
            'pagination': {
              'rowsPerPage': 0,
              'descending': false,
              'sortBy': 'name',
            },
            'fieldName': 'list',
            'addType': 'last',
            'fakeDelete': true,
            duplicateRules: {
              uniqueField: 'jobCode'
            },
            'columns': [
              {
                label: 'Công việc',
                fieldName: 'name',
                field: 'name',
                name: 'name',
                type: 'TextField',
                validation: 'required',
                align: 'center',
                sortable: true,
              },
              {
                label: 'Mã CV',
                fieldName: 'jobCode',
                field: 'jobCode',
                name: 'jobCode',
                type: 'TextField',
                align: 'center',
                validation: {
                  'required': true,
                }
              },
              {
                label: 'Loại',
                fieldName: 'jobCategory',
                field: 'jobCategory',
                name: 'jobCategory',
                type: 'Select',
                align: 'center',
                '@tableOnly': {
                  showFormat: 'this.$getNameById(this.$store.getters.jobStore.categories,props.row.jobCategory,"name")',
                },
                datasource: {
                  options: [],
                  label: 'name',
                  value: 'id',
                  displayValue: 'this.$getNameById(this.$store.getters.jobStore.categories,value,"name")',
                  emitValue: true,
                },
                validation: 'required',
              },
              {
                label: 'Đơn vị',
                fieldName: 'unit',
                field: 'unit',
                name: 'unit',
                type: 'TextField',
                // validation: 'required',
                align: 'center'
              }
            ]
          }
        }
      },
      queryPath: ['Masterdata', 'Jobs'],
      data: []
    }
  },
  created() {
    let accept = ['F1M', 'F2M', 'F3M', 'F4M', 'F5M', 'BOM']
    let roles = this._.get(this.permission, 'roles')
    let val = roles ? this._.intersection(Object.keys(roles), accept).length > 0 : false
    this.scaffolding.items['item-1'].editable = val
    // this.root = this.$store.getters.jobStore.list
  },
  computed: {
    hasPerm: {
      get: function() {
        let accept = ['F1M', 'F2M', 'F3M', 'F4M', 'F5M', 'BOM']
        let roles = this._.get(this.permission, 'roles')
        return roles ? this._.intersection(Object.keys(roles), accept).length > 0 : false
      }
    },
    permission() {
      return this.$store.getters.permission
    },
  },
  watch: {
    permission (newValue) {
      let accept = ['F1M', 'F2M', 'F3M', 'F4M', 'F5M', 'BOM']
      let roles = this._.get(newValue, 'roles')
      let val = roles ? this._.intersection(Object.keys(roles), accept).length > 0 : false
      this.scaffolding.items['item-1'].editable = val
    }
  },
  methods: {
    async handlerSubmit (payload, resolve, reject) {
      let vm = this
      let submitModel = { coll: 'Masterdata', id: 'Jobs', data: payload.data}
      await vm.$command.execute('upMasterDatAID', submitModel).then(res => resolve(res)).catch(err => reject(err))
    },
    putOpt(data) {
      this.scaffolding.items['item-1'].columns[2].datasource.options = data.categories
    }
  },
  components: {
    DetailPage
  }
}
</script>
